import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ButtonTypes} from './button-types.enum';

@Component({
  selector: 'li3-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {
  @Input() btnCaption: string;
  @Input() btnType: ButtonTypes;
  @Input() testId: string;
  @Input() showBusyIndicator = false;
  @Output() clicked = new EventEmitter();

  btnTypes = ButtonTypes;

  constructor() {
  }

  ngOnInit() {
  }

  onClick() {
    this.clicked.emit();
  }
}
